import { render, staticRenderFns } from "./TradeBulkDeleteModal.vue?vue&type=template&id=b7c76bec&"
import script from "./TradeBulkDeleteModal.vue?vue&type=script&lang=js&"
export * from "./TradeBulkDeleteModal.vue?vue&type=script&lang=js&"
import style0 from "./TradeBulkDeleteModal.vue?vue&type=style&index=0&id=b7c76bec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports